(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["disney-jackets-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('disney-jackets-products')) {
    customElements.define(
      'disney-jackets-products',
      class extends HTMLElement {
        connectedCallback() {
          this.handleClick = (event) => {
            const button = event.target.closest('.disney-jackets-products__quick-view');
            if (!button || !this.contains(button)) return;
            const productUrl = button.dataset.productUrl;
            if (!productUrl) return;
            if (typeof window.patpatR$1 === 'function') {
              window.patpatR$1('quick-view:open', null, { productUrl });
            } else {
              window.location.href = productUrl;
            }
          };
          this.addEventListener('click', this.handleClick);
          const list = this.querySelector('.disney-jackets-products__products');
          const controls = this.querySelector('.disney-jackets-products__scroll-controls');
          const prev = controls.querySelector('.disney-jackets-products__scroll-button--prev');
          const next = controls.querySelector('.disney-jackets-products__scroll-button--next');
          this.scrollController = new AbortController();
          const { signal } = this.scrollController;
          const update = () => {
            const maxScroll = list.scrollWidth - list.clientWidth;
            controls.hidden = maxScroll <= 1;
            prev.disabled = list.scrollLeft <= 1;
            next.disabled = list.scrollLeft >= maxScroll - 1;
          };
          const scroll = (direction) => {
            list.scrollBy({ left: direction * (list.clientWidth + 12), behavior: 'smooth' });
          };
          prev.addEventListener('click', () => scroll(-1), { signal });
          next.addEventListener('click', () => scroll(1), { signal });
          list.addEventListener('scroll', update, { passive: true, signal });
          window.addEventListener('resize', update, { signal });
          this.scrollObserver = new ResizeObserver(update);
          this.scrollObserver.observe(list);
          update();
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.scrollController?.abort();
          this.scrollObserver?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip-group"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ip-group')) {
    customElements.define('ip-group', class extends HTMLElement {
      connectedCallback() {
        this.handleClick = (event) => {
          const button = event.target.closest('.ip-group__quick-view');
          if (!button || !this.contains(button)) return;
          const productUrl = button.dataset.productUrl;
          if (!productUrl) return;
          event.preventDefault();
          event.stopPropagation();
          if (typeof window.patpatR$1 === 'function') {
            window.patpatR$1('quick-view:open', null, { productUrl });
          } else {
            window.location.href = productUrl;
          }
        };
        this.addEventListener('click', this.handleClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ip-image-video')) {
    customElements.define('ip-image-video', class extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.visibleVideos = new Set();
        this.updatePlayback = () => {
          this.videos.forEach((video) => {
            if (!this.visibleVideos.has(video) || document.hidden || !video.getClientRects().length) {
              video.pause();
              return;
            }
            if (!video.dataset.loaded) {
              video.poster = video.dataset.poster;
              video.querySelectorAll('source').forEach((source) => {
                source.src = source.dataset.src;
              });
              video.dataset.loaded = 'true';
              video.load();
            }
            video.muted = true;
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          });
        };
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.visibleVideos.add(entry.target);
              else this.visibleVideos.delete(entry.target);
            });
            this.updatePlayback();
          });
          this.videos.forEach((video) => this.observer.observe(video));
        } else {
          this.visibleVideos = new Set(this.videos);
          this.updatePlayback();
        }
        document.addEventListener('visibilitychange', this.updatePlayback);
        window.addEventListener('resize', this.updatePlayback);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('visibilitychange', this.updatePlayback);
        window.removeEventListener('resize', this.updatePlayback);
        this.videos.forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
